export function CalendarIcon({ hovered }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="calendar-icon"
    >
      <path
        d="M10.0019 9.16047C12.6323 9.16047 15.2628 9.16047 17.8933 9.16047C18.3251 9.16047 18.3251 9.16109 18.3251 9.60647C18.3251 11.6154 18.327 13.6249 18.3245 15.6338C18.3226 17.2904 17.2892 18.3311 15.6422 18.3317C11.8785 18.3336 8.11468 18.3342 4.3509 18.3317C2.71833 18.3304 1.67675 17.2904 1.67426 15.66C1.67113 13.6205 1.67925 11.5804 1.66739 9.53963C1.66552 9.2423 1.7454 9.15234 2.04807 9.15422C4.69913 9.16546 7.35082 9.16047 10.0019 9.16047Z"
        fill={hovered ? "#A4A5B1" : "#135BA6"}
        style={{ transition: "all 0.3s ease-out" }}
      />
      <path
        d="M5.00573 4.16703C5.00573 3.60608 5.00386 3.09699 5.00636 2.58789C5.00885 2.04507 5.32838 1.68214 5.81266 1.66715C6.30692 1.65153 6.66264 2.01446 6.67388 2.5679C6.68449 3.08512 6.67637 3.60296 6.67637 4.14079C8.90556 4.14079 11.0942 4.14079 13.324 4.14079C13.324 3.69791 13.3215 3.27439 13.3252 2.85025C13.3265 2.68409 13.324 2.51543 13.3514 2.35302C13.4245 1.91951 13.7871 1.64091 14.2183 1.66902C14.6458 1.69713 14.9803 2.02508 14.9909 2.46171C15.0046 3.01266 14.994 3.56361 14.994 4.16078C15.1781 4.16078 15.3416 4.17077 15.5032 4.15953C17.2007 4.03897 18.4501 5.29953 18.3272 7.00109C18.3159 7.15351 18.3259 7.3078 18.3259 7.47958C12.7636 7.47958 7.23741 7.47958 1.69753 7.47958C1.6114 6.51261 1.68504 5.6181 2.41084 4.88788C3.1279 4.16765 4.03093 4.11768 5.00573 4.16703Z"
        fill={hovered ? "#A4A5B1" : "#135BA6"}
        style={{ transition: "all 0.3s ease-out" }}
      />
    </svg>
  );
}
